import { Alert, AlertTitle, AlertDescription } from "@aisquare/ui";
import { InfoIcon, TriangleAlertIcon } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function AlertDemo() {
  return (
    <Section
      id="alert"
      title="Alert"
      description="Banner-style message surface. Default + destructive variants. Optional leading icon."
    >
      <VariantBlock label="Variants">
        <div className="grid w-full max-w-2xl gap-3">
          <Alert>
            <InfoIcon />
            <AlertTitle>Heads up — read me first.</AlertTitle>
            <AlertDescription>
              Default alert. Use this for neutral information.
            </AlertDescription>
          </Alert>
          <Alert variant="destructive">
            <TriangleAlertIcon />
            <AlertTitle>Could not save changes</AlertTitle>
            <AlertDescription>
              Destructive alert. Surfaces errors that block the user.
            </AlertDescription>
          </Alert>
        </div>
      </VariantBlock>

      <VariantBlock label="No icon" caption="title + description only">
        <div className="grid w-full max-w-2xl gap-3">
          <Alert>
            <AlertTitle>Composes without an icon.</AlertTitle>
            <AlertDescription>
              Grid template collapses when no `&gt;svg` child is present.
            </AlertDescription>
          </Alert>
        </div>
      </VariantBlock>
    </Section>
  );
}
